import { PDF_MIMES } from '../../config/variables';
import {
  ContentDocumentSchema,
  ContentProcessingLogSchema,
} from '../../definitions/schemas';
import { ContentProcessingStatus } from '../../enums/ContentProcessingLogs';
import { EventProperty } from '../../tools/Analytics';

export interface DocumentViewerCommonProps {
  contentId: string;
  document: ContentDocumentSchema;
  downloadable?: boolean;
  downloadTrigger?: number;
  onDownload?: () => void;
  onLoad?: (numPages: number) => void;
  previewDialog?: boolean;
  rounded?: boolean;
  theaterMode?: boolean;
  trackingProperties?: EventProperty;
  width?: number;
}

export interface FullScreenDocument extends HTMLElement {
  mozRequestFullScreen(): Promise<void>;
  msRequestFullscreen(): Promise<void>;
  webkitRequestFullscreen(): Promise<void>;
}

export const canBeFullScreen = () => {
  const itemToFullScreen = document.body as FullScreenDocument;
  return (
    !!itemToFullScreen.requestFullscreen ||
    !!itemToFullScreen.mozRequestFullScreen ||
    !!itemToFullScreen.webkitRequestFullscreen ||
    !!itemToFullScreen.msRequestFullscreen
  );
};
export const isDocumentComplete = (doc: ContentDocumentSchema) =>
  doc && doc.filesize && doc.filesize > 0;

export const skipPolling = (
  doc: ContentDocumentSchema,
  contentProcessingLog?: ContentProcessingLogSchema
) =>
  (doc.mime && PDF_MIMES.includes(doc.mime)) ||
  (doc &&
    isDocumentComplete(doc) &&
    contentProcessingLog?.status !== ContentProcessingStatus.Processing);
